<template>
    <section class="position-relative">
        <cargando v-if="cargando" />
        <div class="row mx-0 align-items-center">
            <div class="col-auto f-500 f-18 text-general px-0">
                Biblioteca
            </div>
            <div class="col-xl-2 col-lg-3 ml-auto">
                <el-input v-model="buscar" prefix-icon="icon-search" class="w-100 br-20" placeholder="Buscar carpeta" size="small" />
            </div>
            <div class="btn-general f-14 px-3 " @click="modalCrear">
                Crear Carpeta
            </div>
        </div>
        <div class="custom-scroll overflow-auto pt-4" style="height:calc(100vh - 126px)">
            <div class="row mx-0 bg-white br-8 px-2">
                <div v-for="c in carpetas.filter(c => !buscar || JSON.stringify(c.carpeta).toLowerCase().includes(buscar.toLowerCase()))" :key="c.id" class="mr-4  mt-2 mb-3" style="width:110px;" >
                    <div class="position-relative">
                        <div class="ml-auto mr-2" style="position: absolute; top:16px; right: -28px;">
                            <el-popover ref="popoverOptions" placement="bottom" trigger="hover" effect="light">
                                <div class="row mx-0 cr-pointer p-2 f-12 item-popover" @click="modalEditar(c)">
                                    Editar 
                                </div>
                                <div class="row mx-0 cr-pointer p-2 f-12 item-popover" @click="modalEliminar(c.id)()">
                                    Eliminar
                                </div>
                                <div slot="reference" class="btn-action-outline-small">
                                    <i class="icon-dots-vertical cr-pointer f-20" />
                                </div>
                            </el-popover>
                        </div>
                    </div>
                    <img src="/img/icons/folder.svg" width="110" height="110" class="br-t-12 obj-cover cr-pointer" @click="$router.push({name: 'admin.docs.ver', params: {id_carpeta: c.id}})"/>
                    <div class="row cr-pointer" @click="$router.push({name: 'admin.docs.ver', params: {id_carpeta: c.id}})">
                        <div class="col-12 text-general text-center f-12">
                            {{c.carpeta}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="custom-scroll overflow-auto pt-4" style="height:calc(100vh - 111px)">
        </div> -->
        <!-- Partials -->
        <modal ref="modalCrearCarpeta" titulo="Crear Carpeta" icon="carpeta_nueva" no-aceptar adicional="Guardar" @adicional="crearCarpeta">
            <p class="text-general f-15 pl-3">Nombre de carpeta</p>
            <el-input v-model="form.nombre" show-word-limit maxlength="60" />
	    </modal>
        <modal ref="modalEditarCarpeta" titulo="Editar Carpeta" icon="carpeta_nueva" no-aceptar adicional="Actualizar" @adicional="editarCarpeta">
            <p class="text-general f-15 pl-3">Nombre de carpeta</p>
            <el-input v-model="form.nombre" show-word-limit maxlength="60" />
	    </modal>
        <modalSiNo
            ref="modalEliminarCarpeta"
            titulo="Eliminar Carpeta"
            mensaje="¿Desea eliminar esta carpeta y todo su contenido?"
            icon="close"
            @accion="eliminarCarpeta"
            />
    </section>
</template>

<script>
//import {mapGetters} from 'vuex'
import Service from '~/services/biblioteca/biblioteca'
export default {
    components: {
       //modalCrear: () => import('./partials/modalCrearEmpacador')
    },
    data(){
        return {
            cargando: false,
            carpetas: [],
            buscar: '',
            form: {
                nombre: ''
            }
        }
    },
    computed:{
        // ...mapGetters({
        //     id_cedis:'cedis/id_cedis',
        // }),
    },
    mounted(){
        this.getCarpetas();
    },
    methods: {
        async getCarpetas(){
            try{
                this.cargando = true;
                const {data} = await Service.getCarpetas()
                this.carpetas = data.data.carpetas;
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
        async crearCarpeta() {
            try{
                if (!this.form.nombre) return
                this.cargando = true;
                const {data} = await Service.crearCarpeta(this.form)
                this.notificacion('Mensaje', 'Carpeta creada correctamente', 'success');
                await this.getCarpetas();
                this.$refs.modalCrearCarpeta.toggle();
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
        async editarCarpeta() {
            try{
                if (!this.form.nombre) return
                if(!this.form.id) return
                this.cargando = true;
                const {data} = await Service.editarCarpeta(this.form)
                await this.getCarpetas();
                this.$refs.modalEditarCarpeta.toggle();
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
        async eliminarCarpeta() {
            try{
                if(!this.form.id) return
                this.cargando = true;
                const {data} = await Service.eliminarCarpeta(this.form.id)
                this.notificacion('Mensaje', 'Carpeta eliminada', 'success');
                this.form.id = null;
                await this.getCarpetas();
                this.$refs.modalEliminarCarpeta.toggle();
            } catch (e){
                this.error_catch(e)
            } finally{
                this.cargando = false
            }
        },
        
        modalCrear(){
            this.form.id = null;
            this.form.nombre = "";
            this.$refs.modalCrearCarpeta.toggle();
        },
        modalEditar(item){
            this.form.id = item.id;
            this.form.nombre = item.carpeta;
            this.$refs.modalEditarCarpeta.toggle();
        },
        modalEliminar(id){
            this.form.id = id;
            this.$refs.modalEliminarCarpeta.toggle();
        },
    }
}
</script>
<style lang="scss" scoped>
.card-picking{
    width: 162px;
    height: 283px;
    border-radius: 12px;
    background-color: #FFFFFF;
    box-shadow: 1px 2px 8px #6B707414;
}
</style>